import React from 'react';
import CommonModal from '../../Modal/modal';
import styles from '../../../../css/NavigatorBar/NavigatorContents/navInfoContent.module.css';
import { ReactComponent as DotSVG } from '../../../../assets/icons/svg/dot.svg';

function NavInfoContent(data) {
  // 선박 및 선실 세부 정보를 탭 콘텐츠로 렌더링한다.
  const { shipImage, shipBrand, shipIcon, cabinData, infoData } = data;
  const handleImgError = (event) => {
    if (event?.currentTarget) {
      event.currentTarget.style.display = 'none';
    }
  };
  const normalizeDescription = (value) => (
    (value || '')
      .replace(/\\r\\n|\\r|\\n/g, '\n')
      .replace(/<br\s*\/?\s*>/gi, '\n')
      .replace(/\r\n|\r|\n/g, '\n')
  );

  const extractCabinNames = (cabins) => {
    const names = [];
    const seen = new Set();
    if (!Array.isArray(cabins)) return names;

    cabins.forEach(cabin => {
      const name = (cabin?.name_ko || cabin?.name || '').trim();
      if (!name || seen.has(name)) return;
      seen.add(name);
      names.push(name);
    });

    return names;
  };
  // console.log(cabinData);
  return (
    <div>
      {/* 선박 정보 */}
      <div className={styles['cruise-info-wrapper']}>
        <h2 className={styles['cruise-title']}>선박 정보</h2>

        <img
          src={shipImage}
          alt="cruise-image"
          className={styles['cruise-image']}
          onError={handleImgError}
        />

        <div className={styles['cruise-info-detail']}>
          <div className={styles['cruise-brand']}>
            <img
              src={shipIcon}
              alt="brand"
              className={styles['cruise-brand-icon']}
              onError={handleImgError}
            />
            <span className={styles['cruise-brand-name']}>{shipBrand}</span>
          </div>

          <ul>
            {infoData.map((d, i) => (
              <li key={i}>
                <div className={styles['detail-info']}>
                  <div className={styles.dotWrapper} style={{marginRight:'5px'}}>
                    <DotSVG />
                  </div>
                  {d.value && (
                    <div className={styles['detail-info-value']}>
                      <span className={styles['detail-label']}>{d.label}</span>
                      <span className={styles['detail-value']}>{d.value}</span>
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* 선실 정보 */}
      <div className={styles['cabin-info-wrapper']}>
        <h2 className={styles['cabin-title']}>선실 정보</h2>
        {cabinData.map((cabin, idx) => {
          const cabinNames = extractCabinNames(cabin.cabins);
          const displayLabels = cabinNames;

          return (
          <div className={styles['cabin-card']} key={idx}>
            <img
              src={cabin.image}
              alt={cabin.cabinType}
              className={styles['cabin-image']}
              onError={handleImgError}
            />
            <div className={styles['cabin-info-box']}>
              <div className={styles['cabin-type']}>
                <h2 className={styles['carbin-name']}>{cabin.cabinType}</h2>
                {displayLabels.length > 0 && (
                  <ul>
                    {displayLabels.map((label, i) => (
                      <li key={`${cabin.cabinType}-term-${i}`}>
                        <div className={styles.dotWrapper}>
                          <DotSVG />
                        </div>
                        <span>{label}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className={styles['btn-wrapper']}>
                
                <CommonModal
                  trigger={
                    <button className={`${styles['cabin-view-btn']} btn`}>
                      {cabin.cabinType} 선실 모두 보기
                    </button>
                  }
                  title={`${cabin.cabinType} 선실 모두 보기`}
                  showFooter={false}
                >
                  <div className={styles['cabin-view-modal-body']}>
                    {
                      cabin.cabins.map((cabinDetail, i) => (
                        <div className={styles['cabin-view-modal-item']} key={i}>
                          <h2 className={styles['item-name']}>{cabinDetail.name_ko || cabinDetail.name}</h2>
                          <div className={styles['item-info-wrapper']}>
                            <ul>
                              <li className={styles['item-desc']}>
                                {(cabinDetail.description_ko || cabinDetail.description_en || '')
                                  .replace(/\\r\\n|\\r|\\n/g, '\n')
                                  .replace(/<br\s*\/?\s*>/gi, '\n')
                                  .replace(/\r\n|\r|\n/g, '\n')}
                              </li>
                            </ul>
                            {/* <p className={styles['item-price']}>
                              {Number((cabinDetail.price / 2) || 0).toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD'
                              })}
                            </p> */}
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </CommonModal>
              </div>
            </div>
          </div>
        );
        })}
      </div>
    </div>
  );
}

export default NavInfoContent;
